module.exports = __webpack_public_path__ + "img/icon_1.c8bec5ac.png";